__webpack_require__.p = "/magic/";